/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DayOfWeekFromJSON, DayOfWeekToJSON, } from './';
export function TimeRangeOfDayFromJSON(json) {
    return TimeRangeOfDayFromJSONTyped(json, false);
}
export function TimeRangeOfDayFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dayOfWeek': DayOfWeekFromJSON(json['dayOfWeek']),
        'from': json['from'],
        'to': json['to']
    };
}
export function TimeRangeOfDayToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dayOfWeek': DayOfWeekToJSON(value.dayOfWeek),
        'from': value.from,
        'to': value.to
    };
}
